import * as Yup from 'yup';
import { phoneRegExp } from '../../../util/helpers/phoneRegex';

export const emailValidation = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Required')
});

export const phoneValidation = Yup.object().shape({
  phone: Yup.string().matches(phoneRegExp, 'Invalid.').required('Required')
});
